import '../../App.css';
import React, { useContext, useEffect, useState, useCallback } from "react";
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { IoMdEye, IoMdGrid } from "react-icons/io";
import { FaPlus } from 'react-icons/fa'
import ModalCadastrarCapacidade from '../../components/modal/ModalCadastrarCapacidade';
import ModalArvoreCapacidade from '../../components/modal/ModalArvoreCapacidade';
import ModalEditarCapacidade from '../../components/modal/ModalEditarCapacidade';
import ModalMapaCalor from '../../components/modal/ModalMapaCalor';
import ModalExcluirCapacidade from '../../components/modal/ModalExcluirCapacidade';
import { TbPencil, TbTrash } from "react-icons/tb";
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function CapacidadeNegocioDemanda() {
    const { CapacidadesConsulta, modalEditarOpen, loading, ListaCapacidadesConsulta, setModalEditar, setDemandaAtual, Success, Error, setCapacidadeAtualKey, setEdicaoCapacidade, Permissao, ListaSistemas, ListaFiltroCapacidade, totalRegistrosCapacidade, filtroCapacidade, totalRegistrosFiltroCapacidade, AtualizarStatus, setModalExcluirCapacidade, modalExcluirCapacidade } = useContext(ApiContext)
    const [modalMapaCalor, setModalMapaCalor] = useState(false);
    const { h3Demanda, corTerciaria, btnCriar, btnVer } = useContext(StyleContext)
    const [abreModal, setAbreModal] = useState(false)
    const [openModal, setopenModal] = useState(false)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCadastro = (props) => {
        setDemandaAtual(props)
        setModalEditar(true)
        setCapacidadeAtualKey(props.key)
        setEdicaoCapacidade(props)
    }

    const DeletarCapacidade = (props) => {
        setCapacidadeAtualKey(props.key)
        setModalExcluirCapacidade(true)
    }

    useEffect(() => {
        ListaSistemas()
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCapacidade(searchTerm, currentPage, pageSize);
        } else {
            ListaCapacidadesConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCapacidade : totalRegistrosCapacidade;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {modalMapaCalor &&
                <ModalMapaCalor setModalMapaCalor={setModalMapaCalor} />
            }
            {openModal &&
                <ModalCadastrarCapacidade currentPage={currentPage} setopenModal={setopenModal} />
            }
            {abreModal &&
                <ModalArvoreCapacidade setAbreModal={setAbreModal} />
            }
            {modalExcluirCapacidade &&
                <ModalExcluirCapacidade currentPage={currentPage} />
            }
            {loading &&
                <LoadingScreen />
            }
            <Header pagina={'Cadastros'} subpagina={'Capacidade Negócio Demanda'}></Header>
            <MenuLateral></MenuLateral>
            <div className="container-principal">
                <div className="demanda-header">
                    <button className='btn-dash btn-ver' style={{ ...btnVer, marginRight: '15px' }} onClick={setModalMapaCalor}><IoMdGrid style={{ marginRight: "10px" }} />Mapa de Calor</button>
                    <button className='btn-dash btn-ver' style={btnVer} onClick={setAbreModal}><IoMdEye style={{ marginRight: "10px" }} />Ver árvore</button>
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={setopenModal}><FaPlus style={{ marginRight: "10px" }} />Novo</button>
                    }
                    {modalEditarOpen &&
                        <ModalEditarCapacidade currentPage={currentPage} />
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Capacidades de Negócio cadastradas</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroCapacidade : CapacidadesConsulta}
                        columns={[
                            { label: "Nível", field: "nivel", width: "40%", render: (x) => x.nivel || "-" },
                            { label: "Título", field: "titulo", width: "40%", render: (x) => x.titulo || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type='checkbox' checked={x.ativo} className="toggleBtn" onChange={() => AtualizarStatus("CapacidadeNegocioDemanda", x.key, !x.ativo, currentPage)} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditCadastro(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarCapacidade(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroCapacidade(term, 1, 10);
                            } else {
                                ListaCapacidadesConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div >
            <Footer></Footer>
        </>
    );
}

export default CapacidadeNegocioDemanda;